import { State } from "@store/types";

export const notifications = (state: State) => state.getIn(["notification", "notifications"]);